import { render, staticRenderFns } from "./pendingTrash.vue?vue&type=template&id=3e11ccf8"
import script from "./pendingTrash.vue?vue&type=script&lang=js"
export * from "./pendingTrash.vue?vue&type=script&lang=js"
import style0 from "./pendingTrash.vue?vue&type=style&index=0&id=3e11ccf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports